// src/pages/auth/UnauthorizedPage.js
export function UnauthorizedPage() {
  return (
    <div style={page}>
      <span style={icon}>🔒</span>
      <h2 style={title}>Access Denied</h2>
      <p style={text}>You don't have permission to view this page. Contact your administrator.</p>
    </div>
  );
}

// src/pages/auth/InactivePage.js
export function InactivePage() {
  return (
    <div style={page}>
      <span style={icon}>⏸</span>
      <h2 style={title}>Account Inactive</h2>
      <p style={text}>Your account has been deactivated. Contact your administrator.</p>
    </div>
  );
}

const page = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: "'DM Sans', sans-serif",
  background: '#f8f7f4',
  textAlign: 'center',
  padding: 24,
};
const icon = { fontSize: 48, marginBottom: 16, display: 'block' };
const title = { fontSize: 22, fontWeight: 700, color: '#1a1f16', margin: '0 0 8px' };
const text = { fontSize: 15, color: '#8a9485', margin: 0, maxWidth: 360 };
